import React, { useState } from 'react';
import axios from 'axios';
import { Button, Snackbar, Alert, Box, Typography, CircularProgress, TextField, Grid } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL;

const GenerateOTPButton = ({ sessionId }) => {
  const [otp, setOtp] = useState('');
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const generateOTP = async () => {
    setLoading(true);
    setMessage('');
    try {
      const response = await axios.post(`${API_URL}/generate-otp/`, { session_id: sessionId });

      setOtp(response.data.OTP);
      setIsOtpGenerated(true);
      setMessage('OTP generated successfully!');
      setOpen(true);
    } catch (error) {
      setMessage('Error generating OTP');
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const regenerateOTP = async () => {
    setLoading(true);
    setMessage('');
    try {
      const response = await axios.post(`${API_URL}/generate-otp/`, { session_id: sessionId });

      setOtp(response.data.OTP);
      setMessage('OTP regenerated successfully!');
      setOpen(true);
    } catch (error) {
      setMessage('Error regenerating OTP');
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: '#1e1e1e',
        padding: 4,
        borderRadius: 2,
        boxShadow: 3,
        width: '100%',
        maxWidth: '500px',
        margin: 'auto',
        mt:5,
      }}
    >
      <Grid container direction="column" spacing={3} justifyContent="center" alignItems="center">
        {/* OTP display */}
        <Grid item xs={12}>
          <Typography variant="h6" component="h1" sx={{ textAlign: 'center', color: '#1E90FF', letterSpacing: 4 }}>
            OTP
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center', fontSize: { xs: '1rem', sm: '1.2rem' }, color: '#ecf0f1', letterSpacing: 3 }}>
            <strong>{otp}</strong>
          </Typography>
        </Grid>

        {/* OTP Helper Text */}
        <Grid item xs={12}>
          <Typography variant="body2" sx={{ textAlign: 'center', color: '#bdc3c7', letterSpacing: 3 }}>
            {isOtpGenerated
              ? 'Your OTP has been generated. Use it to authenticate.'
              : 'Click the button to generate a one-time password (OTP) for authentication.'}
          </Typography>
        </Grid>

        {/* Generate OTP Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={isOtpGenerated ? regenerateOTP : generateOTP}
            fullWidth
            disabled={loading}
            sx={{
              padding: { xs: '0.75rem 1rem', sm: '0.875rem 1.5rem' },
              fontSize: { xs: '0.875rem', sm: '1rem' },
              textAlign: 'center',
              marginTop: 2,
              letterSpacing: 3,
            }}
            startIcon={loading && <CircularProgress size={24} />}
          >
            {loading ? 'Processing...' : isOtpGenerated ? 'Regenerate OTP' : 'Generate OTP'}
          </Button>
        </Grid>
      </Grid>

      {/* Snackbar for feedback */}
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity={message === 'OTP generated successfully!' ? 'success' : 'error'} sx={{ width: '100%', letterSpacing: 4 }}>
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default GenerateOTPButton;
